import {createSelector} from 'reselect';

import {getUIState} from '../../../../ui-selectors';

const getWhatsAppState = createSelector([getUIState], (uiState) => uiState.whatsapp);

const getWhatsAppChartState = createSelector(
    [getWhatsAppState],
    (whatsapp) => whatsapp.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getWhatsAppChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getWhatsAppChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getWhatsAppChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getWhatsAppChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
